export default __webpack_public_path__ + "static/media/cairo.9af645d1.png";